module.exports = __webpack_public_path__ + "static/media/medieval-avatars.90658a50.png";